function resolvePublicAsset(path) {
  if (!path) {
    return path;
  }

  if (/^(?:[a-z]+:)?\/\//i.test(path) || path.startsWith('data:')) {
    return path;
  }

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;

  return `${process.env.PUBLIC_URL || ''}${normalizedPath}`;
}

export default resolvePublicAsset;